import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';

export const CopyConnectInfoModal = ({ show, onHide }) => (
  <Modal
    name="copy-connect-help-modal"
    show={show}
    size="lg"
    onHide={onHide}
  >
    <Modal.Header closeButton>
      <Modal.Title>Curate your Database by selecting which Project details you want to link</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <img className="img-fluid" src="/images/copy_connect_walkthrough.png" />
      <div className="px-5 py-4">
        <p className="mb-4">
          Information such as leads, property details, and client contact info can be added from your Database to
           the Project. This allows you to share specific details that are relevant to the deal without sharing your
           entire Database.
        </p>
        <ul>
          <li className="mb-4">
            Contacts and Properties you add to the Project from your Database are automatically linked. If a
             Collaborator on the Project contributes info from their Database, and you would like a copy of that info as
             well, you can add it to your Database via linking.
          </li>
          <li className="mb-4">
            Tasks and Activities that are associated with Contacts/Properties from your Database will show up on the
             Contact/Property record in your Database when you link.
          </li>
          <li className="mb-4">
            By linking, your Database will remain up-to-date and you can take it with you wherever you go.
          </li>
        </ul>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="d-flex align-items-center justify-content-between gap-4 w-100">
        <span>
          For more information on data sharing and privacy, check out the&nbsp;
          <a
            href="https://help.buildout.com/en/articles/9375597-security-and-data-faq"
            rel="noopener noreferrer"
            target="_blank"
          >
            Help Center
          </a>
        </span>
        <button className="btn btn-primary" onClick={onHide}>Done</button>
      </div>
    </Modal.Footer>
  </Modal>
);

CopyConnectInfoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired
};

export default CopyConnectInfoModal;
